import { render, staticRenderFns } from "./borderless.vue?vue&type=template&id=2353c3d6&scoped=true"
import script from "./borderless.vue?vue&type=script&lang=js"
export * from "./borderless.vue?vue&type=script&lang=js"
import style0 from "./borderless.vue?vue&type=style&index=0&id=2353c3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2353c3d6",
  null
  
)

export default component.exports